import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'productPhoto'
})
export class ProductPhotoPipe implements PipeTransform {

  transform(value: any, ...args: unknown[]): unknown {
    console.log(value)
    if (value?.photoUrlList) {
      return value.photoUrlList[0]
    }else{
      return value?.photoUrl
    }
  }

}
